// Arquivo: src/hooks/useAuth.ts  (colar o conteúdo INTEGRAL no Code Mode)
// Login VISUAL FIXO mantido por decisão do proprietário (paridade com o app
// local e com o APP RDR atual): credenciais fixas no cliente, sessão em
// localStorage/sessionStorage. Não é autenticação de servidor: quem protege as
// operações sensíveis são as Functions (request-sienge-sync / publish-snapshot
// exigem sessão Lumi ADMIN ou token do conector).

import { useCallback, useEffect, useState } from 'react'
import type { Role } from '@/domain/engineering'

const AUTH_KEY = 'rdr_auth_user'
const VALID_EMAIL = 'adm@rdrengenharia.com'
const VALID_PASS = 'admin123'

function readStored(): boolean {
  try {
    return localStorage.getItem(AUTH_KEY) === 'true' || sessionStorage.getItem(AUTH_KEY) === 'true'
  }
  catch {
    return false
  }
}

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(readStored)

  useEffect(() => {
    const onStorage = () => setIsAuthenticated(readStored())
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  const login = useCallback((email: string, senha: string): boolean => {
    if (email.trim().toLowerCase() === VALID_EMAIL && senha === VALID_PASS) {
      try {
        localStorage.setItem(AUTH_KEY, 'true')
        sessionStorage.setItem(AUTH_KEY, 'true')
      }
      catch { /* storage indisponível: mantém apenas em memória */ }
      setIsAuthenticated(true)
      return true
    }
    return false
  }, [])

  const signOut = useCallback(() => {
    try {
      localStorage.removeItem(AUTH_KEY)
      sessionStorage.removeItem(AUTH_KEY)
    }
    catch { /* ignore */ }
    setIsAuthenticated(false)
  }, [])

  const role: Role = isAuthenticated ? 'admin' : 'consulta'

  return { isAuthenticated, isAdmin: role === 'admin', role, email: VALID_EMAIL, login, signOut }
}
